import React, { Component } from 'react';
import Dropzone from 'react-dropzone'

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import fetchDux from '../../../state/fetch-dux';
import { actionCreators } from '../../../state/modals-dux';

import Directory from './create-directory';
import FolderList from './FolderList';
import FileDetail from './FileDetail';
import AddFolderForm from './forms/AddFolderForm';
import UploadFileForm from './forms/UploadFileForm';
import { Button, Row, Col } from 'react-bootstrap';
import DeleteFileModal from './DeleteFileModal';

const UploadWrapper = ({ children, onClose }) => {
  return (
    <div className="form">
      <div style={{ textAlign: 'right' }}>
        <span onClick={onClose}>
          <span className="ti ti-close" />
        </span>
      </div>
      <div>
        {children}
      </div>
    </div>
  )
}

class RenderCheckbox extends Component {
  constructor(props) {
    super(props);
    this.state = { checked: false }
  }
  render() {
    const handleChange = (e) => {
      const { checked } = e.target;
      this.setState({ checked })
    }
    return (
      <input type="checkbox" style={{ marginRight: '10px' }} onChange={handleChange} />
    )
  }
}

class BrowseFiles extends Component {
  constructor(props) {
    super(props);
    this.state = { activePath: '/', showAddFolder: false, showAddFile: false, activeFile: null };
    this.setActivePath = this.setActivePath.bind(this);
    this.toggleAddFolder = this.toggleAddFolder.bind(this);
    this.toggleAddFile = this.toggleAddFile.bind(this);
    this.setActiveFile = this.setActiveFile.bind(this);
  }
  componentDidMount() {
    this.props.getAllFiles();
  }
  setActivePath(activePath) {
    this.setState({ activePath, activeFile: null })
  }
  toggleAddFolder() {
    const { showAddFolder } = this.state;
    this.setState({ showAddFolder: !showAddFolder, showAddFile: false, activeFile: null });
  }
  toggleAddFile() {
    const { showAddFile } = this.state;
    this.setState({ showAddFile: !showAddFile, showAddFolder: false, activeFile: null });
  }
  setActiveFile(activeFile) {
    this.setState({ activeFile, showAddFile: false, showAddFolder: false })
  }
  render() {
    const { files, postFolder, uploadFile, deleteFile, isBrowsing, handleAddFile, deleteFileInProgress } = this.props;
    const { activePath, showAddFolder, showAddFile, activeFile } = this.state;
    const structure = new Directory(files || []);
    const { root } = structure;
    const activeDir = structure.getFolder(activePath);
    const { path: parentPath } = structure.getParent(activePath) || {};
    const { path } = activeDir;

    const pathParts = path.substring(1).split('/');

    const handleFolderSubmit = value => {
      if (activePath === '/') {
        postFolder({ folder: value.folder }, null, null, this.toggleAddFolder);
        return;
      }
      const folder = `${activePath.substring(1)}/${value.folder}`
      postFolder({ folder }, null, null, this.toggleAddFolder);
    }

    const handleFileSubmit = ({ files, filenames }) => {
      const folder = activePath === '/' ? '' : activePath.substring(1);
      uploadFile({ files, filenames, folder }, null, null, this.toggleAddFile);
    }

    const handleDeleteFile = (data) => {
      const { file } = data;
      deleteFile(file._id, null, null, () => {
        this.setActiveFile(null);
        this.props.closeModal();
      });
    }

    const onDeleteFile = () => {
      this.props.showModal('DeleteFileModal');
    }

    return (
      <div>
        {!isBrowsing && (
          <div className="header">
            <div className="container-fluid">
              <h1>Files</h1>
            </div>
          </div>
        )}
        <DeleteFileModal
          fileToDelete={activeFile}
          handleDeleteFile={handleDeleteFile}
          deleteFileInProgress={deleteFileInProgress}
        />
        <div className={isBrowsing ? "" : "container"}>
          <div className="path">
            <span className="add">
              <Button type="button" bsSize="sm" bsStyle="hollow-info" onClick={this.toggleAddFolder}>
                <span className="ti ti-plus" /> New Folder
              </Button>
              {' '}
              <Button type="button" bsSize="sm" bsStyle="hollow-info" onClick={this.toggleAddFile}>
                <span className="ti ti-upload" /> Upload File
              </Button>
            </span>
            <div>
              <a className="back" onClick={() => this.setActivePath(parentPath)}>
                <span className="ti ti-arrow-left" />
              </a>
              <a onClick={() => this.setActivePath('/')}>Home</a>
              {path !== '/' && pathParts.map((v, index) => {
                const destinationPath = '/' + pathParts.slice(0, index + 1).join('/');
                const handleSetActivePath = () => this.setActivePath(destinationPath);
                return (
                  <span key={index}>
                    <a className="divider"><span className="ti ti-angle-right" /></a>
                    <a onClick={handleSetActivePath}>{v}</a>
                  </span>
                );
              })}
            </div>
          </div>
          {showAddFolder && (
            <UploadWrapper onClose={this.toggleAddFolder}>
              <AddFolderForm onSubmit={handleFolderSubmit} />
            </UploadWrapper>
          )}
          {showAddFile && (
            <UploadWrapper onClose={this.toggleAddFile}>
              <UploadFileForm onSubmit={handleFileSubmit} />
            </UploadWrapper>
          )}

          <Row>
            <Col sm={6}>
              <FolderList
                {...activeDir}
                setActivePath={this.setActivePath}
                setActiveFile={this.setActiveFile}
                parentPath={parentPath}
                RenderCheckbox={RenderCheckbox}
              />
            </Col>
            <Col sm={6}>
              {activeFile && (
                <FileDetail
                  activeFile={activeFile}
                  onClose={() => this.setActiveFile(null)}
                  isBrowsing={isBrowsing}
                  handleAddFile={handleAddFile}
                  onDeleteFile={onDeleteFile}
                />
              )}
            </Col>
          </Row>

        </div>
      </div>
    )
  }
}

const mapState = state => {
  const {
    result: files,
    error: filesErr
  } = state.getAllFiles.toJS();

  const {
    inProgress: deleteFileInProgress,
    error: deleteFileErr
  } = state.deleteFile.toJS();

  const error = filesErr;

  return {
    error,
    files,
    deleteFileInProgress
  };
};
const mapDispatch = dispatch => bindActionCreators({
  ...actionCreators,
  getAllFiles: fetchDux.getAllFiles.createAction,
  clearGetAllFiles: fetchDux.getAllFiles.clearAction,
  postFolder: fetchDux.postFolder.createAction,
  clearPostFolder: fetchDux.postFolder.clearAction,
  uploadFile: fetchDux.uploadFile.createAction,
  clearUploadFile: fetchDux.uploadFile.clearAction,
  deleteFile: fetchDux.deleteFile.createAction,
}, dispatch);

export default connect(mapState, mapDispatch)(BrowseFiles);



// WEBPACK FOOTER //
// ./src/components/routes/files/BrowseFiles.js